// extracted by mini-css-extract-plugin
module.exports = {"container":"twoColumns-module--container--1J09p","left":"twoColumns-module--left--rmyiR","right":"twoColumns-module--right--1GRk8"};